/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react"
// import { ListGroup, Card, Button } from "react-bootstrap"
import "./Header.scss"
import QuestionModal from "../modals/QuestionModal"
import SignInModal from "../modals/SignIn"
import SignUpModal from "../modals/SignUp"
import { NavLink, Link } from "react-router-dom"
import { connect } from "react-redux"
import { login, getUserByToken, register } from "../services/Api"
import { handleUserSetup } from "../redux/actions/User"
import { Menu, Dropdown, Drawer, Divider } from "antd"
import { DownOutlined, MenuFoldOutlined } from "@ant-design/icons"
import { toast } from "react-toastify"
import VideoModal from "../modals/VideoModal"
import * as firebase from 'firebase/app'; 
import 'firebase/auth';
import 'firebase/firestore';

import CodeVerificationModal from "../modals/CodeVerificationModal"

const EDUCATE_TOKEN = "educate_token"
const AUTH_MODE = {
	signIn: 0,
	signUp: 1
}
class Header extends Component {
	
	state = {
		menuVisible: false,
		modalOpen: false,
		signinmodal: false,
		signupmodal: false,
		videomodalOpen: false,
		displayButtons: "none",
		checkbox: false,
		mode: AUTH_MODE.signIn,
		displayLoginButton: "block",
	}

	verificationCodeObject = null;

	handleLogin = async (values) => {
		const user = {
			email: values.email,
			password: values.password,
			username: values.email,
		}
		const loginUser = await login(user)
		console.log(loginUser)

		if ( 
			loginUser != null &&
			loginUser.message === "Login Successful" &&
			loginUser.user.isVerified === true
		) {
			toast(loginUser.message, { type: "success" })
			localStorage.setItem(EDUCATE_TOKEN, loginUser.access_token)
			this.props.dispatch(handleUserSetup(loginUser.user))
			this.componentDidMount()
			this.setState({
				...this.state,
				signinmodal: false,
			})
		} else if (
			loginUser != null &&
			loginUser.message === "Login Successful" &&
			loginUser.user.isVerified === false
		) {
			toast("Please go to your email and activate your account", {
				type: "error",
			})
		} else {
			if(loginUser){
				toast(loginUser.message, { type: "error" })
			} else {
				toast("This user could not be found!", { type: "error" })
			}
		}
	}

	onCheckBoxClick = async () => {
		this.setState({
			...this.state,
			checkbox: !this.state.checkbox,
		})
	}

	showDrawer = () => {
		this.setState({
			menuVisible: true
		});
	};
	
	onCloseDrawer = () => {
		this.setState({
			menuVisible: false
		});
	};

	handleSignup = async (values) => {
		if (this.state.checkbox === true) {
			const user = {
				email: values.email,
				password: values.password,
				fullname: values.fullname,
				status: "User",
			}
			const registerUser = await register(user)
			toast(registerUser.message, { type: "success" })
		} else {
			toast("You have to agree to the Terms and Conditions", {
				type: "error",
			})
		}
	}

	phoneNumberUsed = async (phoneNumber) => {
		return firebase.firestore().collection("users").where("phone", "==", phoneNumber).get().then( snap => {
			if(!snap.empty){
				return true
			} else {
				return false
			}
		}).catch(error => {
			toast("There was an error and we could not verify this number.", { type: "error"});
			return true;
		})
	}

	handleSigninWithPhone = async (values) => {
		firebase.auth().signInWithPhoneNumber(
			values.phone,
			values.recaptchaVerifier
		)
		.then( res => {
			this.verificationCodeObject = res;
			toast("Code sent!", { type: "success" });
			this.setState({
				mode: AUTH_MODE.signIn
			});
			this.hideSignInModal();
			this.showVerificationCodeModal();
		})
		.catch(error => {
			toast(error.message, {
				type: "error"
			});
		});
	}

	handleSignupWithPhone = async (values) => {
		if (this.state.checkbox === true) {
			const phoneAlreadyUsed = await this.phoneNumberUsed(values.phone);
			if(!phoneAlreadyUsed){
				firebase.auth().signInWithPhoneNumber(
					values.phone,
					values.recaptchaVerifier
				).then( res => {
					this.verificationCodeObject = res;
					this.setState({
						phoneNumber: values.phone,
						fullname: values.fullname,
						mode: AUTH_MODE.signUp
					});
					toast("Code sent!", { type: "success" });
					this.hideSignUpModal();
					this.showVerificationCodeModal();
				})
			} else {
				toast("This number is already registered.", {
					type: "error"
				})
			}
		} else {
			toast("You have to agree to the Terms and Conditions", {
				type: "error",
			})
		}
	}
	

	showSignInModal = () => {
		this.setState({
			...this.state,
			signinmodal: true,
			modalOpen: false,
			signupmodal: false,
			mode: AUTH_MODE.signIn
		})
	}

	hideSignInModal = () => {
		this.setState({
			...this.state,
			signinmodal: false,
		})
	}

	showVerificationCodeModal = () => {
		this.setState({
			verCodeModal: true
		});
	}

	hideVerificationCodeModal = () => {
		this.setState({
			verCodeModal: false
		});
	}

	showSignUpModal = () => {
		this.setState({
			...this.state,
			signupmodal: true,
			modalOpen: false,
			signinmodal: false,
			mode: AUTH_MODE.signUp
		})
	}

	hideSignUpModal = () => {
		this.setState({
			...this.state,
			signupmodal: false,
		})
	}

	handleOpen = () => {
		this.setState({
			...this.state,
			modalOpen: true,
		})
	}
	handleOpenFromDrawer = () => {
		this.setState({
			...this.state,
			modalOpen: true,
			menuVisible: false
		})
	}
	handleClose = () => {
		this.setState({
			...this.state,
			modalOpen: false,
		})
	}
	handleVideoModelOpen = () => {
		this.setState({
			...this.state,
			videomodalOpen: true,
		})
	}
	handleVideoModelOpenFromDrawer = () => {
		this.setState({
			...this.state,
			videomodalOpen: true,
			menuVisible: false
		})
	}
	handleVideoModelClose = () => {
		this.setState({
			...this.state,
			videomodalOpen: false,
		})
		
	}

	logout = () => {
		localStorage.removeItem(EDUCATE_TOKEN)
		this.setState({
			...this.state,
			displayButtons: "none",
			displayLoginButton: "block",

		})
		this.props.dispatch(handleUserSetup(null))
		this.componentDidMount()
	}

	showSignUpModalFromDrawer = () => {
		this.setState({
			menuVisible: false,
			mode: AUTH_MODE.signUp
		}, ()=>{
			this.showSignUpModal();
		})		
	}

	showSignInModalFromDrawer = () => {
		this.setState({
			menuVisible: false,
			mode: AUTH_MODE.signIn
		}, ()=>{
			this.showSignInModal();
		})
	}

	checkLogedIn = async () => {
		if (localStorage.getItem(EDUCATE_TOKEN)) {
			console.log(EDUCATE_TOKEN)
			const user = await getUserByToken()
			this.props.dispatch(handleUserSetup(user.user))
			this.setState({
				...this.state,
				user: true,
				displayButtons: "block",
				displayLoginButton: "none",
			})
		} else {
			console.log("User not logged in")
		}
	}

	componentDidMount() {
		this.checkLogedIn()
	}

	confirmSignInWithPhone = (code) => {
		return this.verificationCodeObject.confirm(code)
			.then( res => {
				toast("Login successful", { type: "success" });
				this.hideVerificationCodeModal();
				this.hideSignInModal();
				this.hideSignUpModal();
				return true;
			}).catch(error => {
				toast("The code you entered is not valid.", { type: "error"});
				return false;
			})
	}

	confirmSignUpWithPhone = (code) => {
		return this.verificationCodeObject.confirm(code)
			.then( res => {
				toast("Account created successfully", { type: "success" });
				this.hideVerificationCodeModal();
				this.hideSignInModal();
				this.hideSignUpModal();
				firebase.firestore().collection("users").doc(res.user.uid).set({
					phone: this.state.phoneNumber,
					fullname: this.state.fullname
				});
				firebase.auth().currentUser.updateProfile({
					displayName: this.state.fullname
				})
				return true;
			}).catch(error => {
				toast("The code you entered is not valid.", { type: "error"});
				return false;
			})
	}

	hideDrawer = () => {
		this.setState({
			menuVisible: false
		})
	}

	formRef = React.createRef()

	render() {
		const menu = (
			<Menu className='notificationHeader'>
				<div className='notificationTitle'>
					<span>{this.props.currentUser.fullName}</span>
					<span>See </span>
				</div>

				<Menu.Item key='1'>
					<Link to='/platform/userQuestions'>Your Content</Link>
				</Menu.Item>
				<Menu.Item key='2'>
					<Link to='/platform/userVideos'>Your Videos</Link>
				</Menu.Item>
				<Menu.Item key='3'>
					<Link to='/terms'>Terms and Conditions</Link>
				</Menu.Item>
				<Menu.Divider />
				<Menu.Item key='4' onClick={() => this.logout()}>
					Log out
				</Menu.Item>
			</Menu>
		)

		return (
			<React.Fragment>
				<div className='headerTop'>
					<div className='leftHeaderSide'>
					<Link to='/'> <div><img className="devimg-fluid2" src={require('../icons/zimblelogo2.png')} /> </div></Link>
						<div className='headerName navbarButton'>
							<NavLink to='/platform/questions'> Questions</NavLink>
						</div>
						<div className='headerName1 navbarButton'>
							<NavLink to='/platform/videos'> Videos</NavLink>
						</div>
						<div className='headerName2'>
							<input
								type='text'
								placeholder='Search'
								className='searchBar'
								onChange={this.props.OnSearch}
							/>
						</div>
					</div>

					<div>
						<div className='rightHeaderSide'>
							<div
								style={{ display: this.state.displayButtons }}
								className='addQuestion'
							>
								<button className="navbarButton" onClick={this.handleOpen}>
									Add a Question
								</button>
							</div>
							<div
								style={{ display: this.state.displayButtons }}
								className='addQuestion'
							>
								<button className="navbarButton"
									onClick={this.handleVideoModelOpen}
								>
									Add a Video
								</button>
							</div>

							<div
								style={{
									display: this.state.displayLoginButton,
								}}
								className='addQuestion'
							>
								<button className="navbarButton" onClick={this.showSignInModal}>
									Sign In
								</button>
								<button className="navbarButton" onClick={this.showSignUpModal}>
									Create an Account
								</button>
							</div>

							<div style={{display: 'none'}}> 
							{ // Will show the bell once we work on notifications
							 }
								<img
									className='headerIcon'
									src={require("../icons/bell.svg")}
								/>
							</div>

							<div style={{ display: this.state.displayButtons }}>
								<Menu className='headtoplink' mode='horizontal'>
									<Menu.Item>
										<Dropdown overlay={menu}>
											<div className='iconCircle'>
												<div className='nameInitial'>
													{this.props.currentUser.fullName && (this.props.currentUser.fullName[0].toUpperCase() || "A")} 
													<DownOutlined />
												</div>
											</div>
										</Dropdown>
									</Menu.Item>
								</Menu>
							</div>


							<span className="openMenuButton">
								<MenuFoldOutlined  onClick={this.showDrawer} />
							</span>
						</div>
					</div>
				</div>

				<QuestionModal
					isOpen={this.state.modalOpen}
					onOpenModal={this.handleOpen}
					onCloseModal={this.handleClose}
				/>
				<VideoModal
					isOpen={this.state.videomodalOpen}
					onOpenModal={this.handleVideoModelOpen}
					onVideoModalClose={this.handleVideoModelClose}
					onCloseModal={this.handleVideoModelClose}
				/>
				<SignInModal
					formRef={this.formRef}
					onSignUpClick={this.showSignInModal}
					visible={this.state.signinmodal}
					onCancel={this.hideSignInModal}
					onCreate={this.handleLogin}
					openSignUp={this.showSignUpModal}
					signInWithPhone={this.handleSigninWithPhone}
				/>
				<SignUpModal
					onCheckBoxClick={this.onCheckBoxClick}
					onCheckBox={this.state.checkbox}
					formRef={this.formRef}
					signUpWithPhone={this.handleSignupWithPhone}
					onSignUpClick={this.showSignUpModal}
					visible={this.state.signupmodal}
					onCancel={this.hideSignUpModal}
					onCreate={this.handleSignup}
					openSignIn={this.showSignInModal}
				/>
				<CodeVerificationModal
					visible={this.state.verCodeModal}
					formRef={this.formRef}
					onSignUpClick={this.showSignUpModal}
					onCancel={this.hideVerificationCodeModal}
					signUpWithPhone={this.confirmSignUpWithPhone}
					onSignIn={this.handleSigninWithPhone}
					signInMode={this.state.mode}
					authWithPhone={this.confirmSignInWithPhone}
				/>
				<Drawer
					title={ this.state.displayLoginButton === "block" ? "Menu" : this.props.currentUser.fullName }
					placement="right"
					closable={true}
					onClose={this.onCloseDrawer}
					visible={this.state.menuVisible}
					maskClosable={true}
				>

					<p><Link to="/platform/questions" onClick={this.hideDrawer}>Questions</Link></p>
					<p><Link to="/platform/videos" onClick={this.hideDrawer}>Videos</Link></p>
					<Divider type="horizontal" />
					<span style={{ display: this.state.displayButtons }}>
						<p onClick={this.hideDrawer}><Link to="/platform/userQuestions">Your Content</Link></p>
						<p onClick={this.hideDrawer}><Link to="/platform/userVideos">Your Videos</Link></p>
						<Divider type="horizontal" />
						<p className="drawerButton" onClick={this.handleOpenFromDrawer}>Add a Question</p>
						<p className="drawerButton" onClick={this.handleVideoModelOpenFromDrawer}>Add a Video</p>
						<Divider type="horizontal" />
					</span>
					<p><Link to="/">Home</Link></p>	
					<p><Link to="/policy">Privacy Policy</Link></p>
					<p><Link to="/terms">Terms and Conditions</Link></p>
					<span style={{ display: this.state.displayLoginButton }}>
						<Divider type="horizontal" />
						<p className="drawerButton" onClick={this.showSignInModalFromDrawer}>Sign In</p>
						<p className="drawerButton" onClick={this.showSignUpModalFromDrawer}>Create an Account</p>
					</span>
					<span onClick={this.hideDrawer} style={{ display: this.state.displayButtons }}>
						<Divider type="horizontal" />
						<p className="drawerButton" onClick={this.logout}>Log out</p>
					</span>
				</Drawer>
			</React.Fragment>
		)
	}
}

function mapStateToProps({ currentUser }) {
	return {
		currentUser: currentUser,
	}
}

export default connect(mapStateToProps)(Header)
